import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import * as $ from 'jquery';
import { SharingDataService } from '../service/sharing-data.service';
declare var $: any;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {

  subscription: Subscription;
  data: {};
  error: string;
  name: string;
  email: string;
  mobile: string;
  useId:any;
  prospectId: string;
  prospectIdFHI: string;
  prospectIdPA: string;
  prospectIdMotor: string;
  prospectIdPI: string;
  prospectIdCovid: string;
  prospectIdWellness: string;
  prospectIdDca: string;
  prospectIdTopUp: string;
  partnerId: string;
  claimsRegisterModal: boolean = true;
  userDetails: object = {};
  loading: boolean;
  notificationCounter: string;
  notificationCount: boolean;
  buyReferPart: boolean = true;
  viewClaimsPart: boolean = false;
  environment = environment;
  requestedQuotes: any = [];
  searchContent:string;
  isShown: boolean = true;
  private onDestroy$: Subject<void> = new Subject<void>();
  url:string;
  showYourPolicies: boolean = false;
  showMFineFGPC: boolean = false;
  freeGpcStatus: any = '';
  showMFineFreeSpecialist: boolean = false;
  showBackBtn:Boolean=false
  showSecurenowFacilities:Boolean=true
  isCorporateHealthCheckupRestricted: boolean = false;
  showPsychiatrist: boolean = false;

  //for disabling div  in production
  constructor(private router: Router, private activatedRoute: ActivatedRoute,private _location: Location, private serviceURLService: serviceURLService,private _sharingDataService:SharingDataService) {
    this.name = localStorage.getItem('name');
    this.email = localStorage.getItem('email');
    this.mobile = localStorage.getItem('mobileNumber');
    this.useId=localStorage.getItem('userID');
    this.showYourPolicies = JSON.parse(localStorage.getItem('showPolicy'));
    this.checkPolicyData();
      this.getAttendanceMFineStatus();
    // this.getOrUpdateFreeGPCStatus();
    this.showMFineFGPC = JSON.parse(localStorage.getItem('mFineFGPC'));
    this.freeGpcStatus = JSON.parse(localStorage.getItem('isFreeGpcSubscribed'));
    this.showMFineFreeSpecialist = JSON.parse(localStorage.getItem('mFineFreeSpecialist'));
    this.isCorporateHealthCheckupRestricted = JSON.parse(localStorage.getItem('isCorporateHealthCheckupRestricted'));
    this.showPsychiatrist = JSON.parse(localStorage.getItem('isPsychiatristTab'));
  }

  ngOnInit() {
    // this.loading = true;
    var hostname = window.location.hostname;
    if (hostname == "staging.securenow.app" || hostname == "localhost") {
      this.partnerId = "997";
    }
    else if (hostname == "securenow.app") {
      this.partnerId = "997";
    }
    // this.getNotificationCount();
    // if(this.mobile!=''){
    //   this.getRequestedQuotes();
    // }
    // const source = interval(15000);
    // this.subscription = source.subscribe(val => this.getNotificationCount());
    $(document).ready(function() {
      $('.carousel').carousel();
      })

  // this.fetCoorporateDetails()
      //this.checkLogOut();
      this.checkAuthVerification();
      this.showYourPolicies = JSON.parse(localStorage.getItem('showPolicy'));
      this.showMFineFGPC = JSON.parse(localStorage.getItem('mFineFGPC'));
      this.showMFineFreeSpecialist = JSON.parse(localStorage.getItem('mFineFreeSpecialist'));
      this.isCorporateHealthCheckupRestricted = JSON.parse(localStorage.getItem('isCorporateHealthCheckupRestricted'));
      this.showPsychiatrist = JSON.parse(localStorage.getItem('isPsychiatristTab'));

      this.activatedRoute.queryParams.subscribe(params => {
        if(params.RedirectFromApp==="true"){
          this.showBackBtn=true
        }
        else{
          this.showBackBtn=false
        }
       
      })
      if((!!localStorage.getItem('pamClientId') && localStorage.getItem('pamClientId').toLowerCase() === "738113".toLowerCase())
        || (!! localStorage.getItem('companyName') && localStorage.getItem('companyName').toLowerCase().trim() === "National Foundation for India-CSOs".toLowerCase().trim())){
        this.showSecurenowFacilities=false
      }
  }

  checkPolicyData(){
    this.loading = true;
    this.serviceURLService.checkPolicies(this.useId,this.mobile).subscribe((successData: any) => {
      if (!!successData.response.pamPolicy || !!successData.response.policyAlert) {
        this.loading = false
        this.showYourPolicies = true;
        localStorage.setItem("showPolicy", "true")
      }
      else {
        this.loading = false
        this.showYourPolicies = false;
        localStorage.setItem("showPolicy", "false")
      }
    }, err => {
      console.log(err)
      this.showYourPolicies = false;
      localStorage.setItem("showPolicy", "false")
      this.loading = false
    })
  }

  // fetCoorporateDetails(){
  //   this.serviceURLService.getCoorporateDetails(this.email).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //   if(successData.message.length>0){
  //     const name=successData.message[successData.message.length-1]
  //       localStorage.setItem('corporateName',name)
  //   }
  //   }, errorData => {
  //       console.log('coorporate email not fetched')
  //   })
  // }
  
  // getRequestedQuotes() {
  //   this.loading = true;
  //   this.serviceURLService.getLatestRetreiveQuote(this.mobile).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //     this.requestedQuotes = successData.response.pamResponse.data.prospects;
  //     this.loading = false;
  //   }, errorData => {
  //     //  this.loading = false;
  //   })
  // }

  redirectToMfine(){ 
    this.saveClickEvent("M-Fine-DSC");
    let firstname = localStorage.getItem('name').split(' ')[0]
    let lastname = localStorage.getItem('name').split(' ')[1]
    let email = localStorage.getItem('email')
    let mobileNumber = '91'+localStorage.getItem('mobileNumber')
    let planData = {}
    let data =  {
      "user_type": "patient",
      "target_url" : environment.targetUrl,
      "user_details": {
      "mobile_number": mobileNumber,
      "firstname": firstname,
      "lastname": lastname,
      "email": email
      }
    }
    this.serviceURLService.reditectToMfineApp(data).subscribe((successData: any) => {
      this.url = successData.redirect_url;
      planData = {
        "plan_id": environment.mfinePlanId,
        "mobile_number": mobileNumber
      }
       console.log(this.url, "url print here")
       // Open the URL in a new tab
        const a = document.createElement('a');
        a.href = this.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();

        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 500);
      // Close the new tab
       console.log("going to call subscribe API")
         this.serviceURLService.mfineSubscribeAPI(planData).subscribe((successData:any)=>{

         }),errorData =>{
          console.log(errorData)
         }
    }), errorData => {
      console.log(errorData)
    } 
  }
  getVisitTeleConsultation(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }
  redirectToFreeGeneralConsultaion(planId: string) {
    this.saveClickEvent("GetVisit-FGPC")
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }

  getVisitPsychiatrist(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }


  // redirectToMfine(){



  //   let data = {
  //     "partnerTokenGeneratorInputIO": {
  //       "partnerId": "516215",
  //       "securityKey": "dkpBQ0Q3cGVGb1NXVnNsWW1EaERWb0ErQVFyTGFhSytNZCtrVzdzRGtrOW1DWktaTDdwWHRWdVZoYnpyV1JseA=="
  //     }
  //   }

  //   this.serviceURLService.reditectToMfineApp(data).subscribe((successData: any) => {
  //     this.url = successData.redirect_url;
  //      console.log(this.url, "url print here")
  //      window.open(this.url)
  //      console.log("going to call subscribe API")
  //       //  let planData = {
  //       //   "plan_id": environment.mfinePlanId,
  //       //   "mobile_number": mobileNumber
  //       //  }
  //       // this.serviceURLService.mfineSubscribeAPI(planData).subscribe((successData:any)=>{

  //       //  }),errorData =>{

  //       //  }
  //   }), errorData => {
    
  //   }


    // let data 
    // let firstname = localStorage.getItem('name').split(' ')[0]
    // let lastname = localStorage.getItem('name').split(' ')[1]
    // let email = localStorage.getItem('email')
    // let  mobileNumber = '91'+localStorage.getItem('mobileNumber')
    // data =  {
    //   "user_type": "patient",
    //   "target_url" : environment.targetUrl,
    //   "user_details": {
    //   "mobile_number": mobileNumber,
    //   "firstname": firstname,
    //   "lastname": lastname,
    //   "email": email
    //   }
    // }
    // this.serviceURLService.reditectToMfineApp(data).subscribe((successData: any) => {
    //   this.url = successData.redirect_url;
    //    console.log(this.url, "url print here")
    //    window.open(this.url)
    //    console.log("going to call subscribe API")
    //      let planData = {
    //       "plan_id": environment.mfinePlanId,
    //       "mobile_number": mobileNumber
    //      }
    //      this.serviceURLService.mfineSubscribeAPI(planData).subscribe((successData:any)=>{

    //      }),errorData =>{

    //      }
    // }), errorData => {
    
    // }

    
  // }

  // redirectToRedCliffe(){
  //   window.location.replace("https://iframeprod.redcliffelabs.com/?partner_id=SecureNow&reference="+localStorage.getItem('mobileNumber'))
  // }
 
  searchInsuropediaResult(searchContent) {
    console.log(searchContent)
    if (searchContent != undefined) {
      localStorage.setItem("insuroSearchContent", searchContent)
      //  this.serviceURLService.getInsuropediaResult(searchContent).subscribe(data =>{
      //    this.insuroContent = data;
      //    this.serviceURLService.changeMessage(data)
      //  })

      this.router.navigate(['insuropedia']);
    }
  }
  closeQuote(){
    console.log('closed')
    this.isShown=false;
    console.log(this.isShown)
  }
  
   // quotes data sort according to date
  //  sortData = (a, b) => {
  //   const bandA = a.date.toUpperCase();
  //   const bandB = b.date.toUpperCase();
  //   let comparison = 0;
  //   if (bandA < bandB) {
  //     comparison = 1;
  //   } else if (bandA > bandB) {
  //     comparison = -1;
  //   }
  //   return comparison;
  // }

  // createProspectForFHI() {

  //   this.data = {
  //     mobile: this.mobile,
  //     prospectId: "",
  //     rmId: "",
  //     product: 95,
  //     email: this.email,
  //     name: this.name,
  //     company: "",
  //     location: "",
  //     designation: "",
  //     comment: "",
  //     partnerId: this.partnerId,
  //     channel: "",
  //     leadSource: "",
  //     googleClickID: "",
  //     couponCode: ""
  //   }
  //   var prospectIdFHI = localStorage.getItem('prospectIdFHI');
  //   if (!prospectIdFHI) {
  //     this.serviceURLService.saveFHIProspect(this.data).subscribe((successData: any) => {
  //       // console.log("Prospect created successfully ",successData)
  //       this.prospectIdFHI = successData.data.prospectId;
  //       localStorage.setItem("prospectIdFHI", this.prospectIdFHI)
  //     }, errorData => {
  //       console.log("Oops..!! there is some error in prospect creation");
  //       if (errorData.error.status === 403) {
  //         this.error = errorData.error.message;
  //       }
  //     })
  //   }
  // }

  createProspectForMotor() {
    const data = {
      mobile: this.mobile,
      prospectId: "",
      rmId: "",
      product: 23,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    window.open(environment.pam2Url + '/individual-insurance/motor-car-insurance-policy/details?redirectionFromApp=true&&mobile='+data.mobile+'&&product='+data.product+'&&email='+data.email+'&&name='+data.name+'&&partnerId='+data.partnerId)

      // this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //   this.prospectIdMotor = successData.data.prospectId;
      //   window.open(environment.pam2Url + '/individual-insurance/motor-car-insurance/details?prospect='
      // + this.prospectIdMotor);
      //   //localStorage.setItem("prospectIdMotor", this.prospectIdMotor)
      // }, errorData => {
      //   if (errorData.error.status === 403) {
      //     this.error = errorData.error.message;
      //   }
      // })
  }
  // createProspectForPA() {

  //   this.data = {
  //     mobile: this.mobile,
  //     prospectId: "",
  //     rmId: "",
  //     product: 129,
  //     email: this.email,
  //     name: this.name,
  //     company: "",
  //     location: "",
  //     designation: "",
  //     comment: "",
  //     partnerId: this.partnerId,
  //     channel: "",
  //     leadSource: "",
  //     googleClickID: "",
  //     couponCode: ""
  //   }
  //   var prospectIdPA = localStorage.getItem('prospectIdPA');
  //   if (!prospectIdPA) {
  //     this.serviceURLService.createProspect(this.data).subscribe((successData: any) => {
  //       // console.log("Prospect created successfully ",successData)
  //       this.prospectIdPA = successData.data.prospectId;
  //       localStorage.setItem("prospectIdPA", this.prospectIdPA)
  //     }, errorData => {
  //       console.log("Oops..!! there is some error in prospect creation");
  //       if (errorData.error.status === 403) {
  //         this.error = errorData.error.message;
  //       }
  //     })
  //   }
  // }

  // createProspectForPI() {

  //   this.data = {
  //     mobile: this.mobile,
  //     prospectId: "",
  //     rmId: "",
  //     product: 83,
  //     email: this.email,
  //     name: this.name,
  //     company: "",
  //     location: "",
  //     designation: "",
  //     comment: "",
  //     partnerId: this.partnerId,
  //     channel: "",
  //     leadSource: "",
  //     googleClickID: "",
  //     couponCode: ""
  //   }
  //   var prospectIdPI = localStorage.getItem('prospectIdPI');
  //   if (!prospectIdPI) {
  //     this.serviceURLService.createProspect(this.data).subscribe((successData: any) => {
  //       console.log("Prospect created successfully ", successData)
  //       this.prospectIdPI = successData.data.prospectId;
  //       localStorage.setItem("prospectIdPI", this.prospectIdPI)
  //     }, errorData => {
  //       console.log("Oops..!! there is some error in prospect creation");
  //       if (errorData.error.status === 403) {
  //         this.error = errorData.error.message;
  //       }
  //     })
  //   }
  // }

  createProspectForWelness() {
    this.loading = true;
    this.data = {
      mobile: this.mobile,
      prospectId: "",
      rmId: "",
      product: 139,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    var prospectIdWellness = localStorage.getItem('prospectIdWellness');
    if (!prospectIdWellness) {
      this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        console.log("Prospect created successfully ", successData)
        this.prospectIdWellness = successData.data.prospectId;
        localStorage.setItem("prospectIdWellness", this.prospectIdWellness)
      }, errorData => {
        this.loading = false;
        console.log("Oops..!! there is some error in prospect creation");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    }
    this.healthAssureUpdate();
  }

  healthAssureUpdate() {
    this.loading = true;
    this.userDetails = {
      UserName: "pujasingh@securenow.in", // hardcode
      FirstName: this.name, //full name
      LastName: "",
      Email: this.email,
      Mobile: this.mobile,
      EmpNo: "", //blank
      DoB: "", //blank
      Gender: "", //blank
      AccessCode: "SN0001", // hardcode
      partnerId: "",
      product: 139,
      company: "",
      designation: "",
      channel: "",
      googleClickID: "",
      leadSource: "Notify-App",
      location: "",
      prospectId: "",
      rmId: ""
    }

    let dataUser = { "userDetails": this.userDetails };


    this.serviceURLService.updateWellnessRegistration(dataUser).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("Wellness regitration successfull ",successData)
      this.loading = true;
      var HALink = successData.response.HALink;
      window.location.href = HALink;
    }, errorData => {
      this.loading = false;
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  createProspectForCovid() {
    console.log('removed')
  }


  createProspectForDCA() {
    this.loading = true;
    this.prospectIdDca = localStorage.getItem('prospectIdDca');
    this.data = {
      mobile: this.mobile,
      prospectId: this.prospectIdDca?this.prospectIdDca:"",
      quoteId: "",
      rmId: "",
      product: 150,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    
      this.serviceURLService.createProspectForDCA(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
        localStorage.setItem("prospectIdDca", successData.data.prospectId);
        window.open(environment.pam2Url + '/individual-insurance/daily-hospital-cash/quote?redirectionFromApp=true&&prospect='
        + successData.data.prospectId);
        this.router.navigate(['/home'])
        return
      },
       errorData => {
        console.log("Oops..!! there is some error in prospect creation");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      });
    
  }

  openMedPay(){
    this.router.navigate(['/medpay']);
  }
  routeSeniorCitizenInsurance() {
    localStorage.setItem("seniorFamdef","")
    localStorage.setItem("sumAssured","")
    localStorage.setItem("premiumAmountSenior","")
    localStorage.setItem("seniorAge","")
    this.router.navigate(['/senior-citizen-insurance']);
  }


  createProspectForTopUp() {
 
    window.open('https://getvital.in/securenow/?referralcode=screnow', '_blank');
  }


  createProspectForHomeLoan() {
    console.log('removed')
  }

  // for Max Life
  createProspectForMaxLife() {
    this.loading = true;
    this.data = {
      mobile: this.mobile,
      prospectId: "",
      quoteId: "",
      rmId: "",
      product: 146,
      email: this.email,
      name: this.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    };
    this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log(successData.data.prospectId, "hello")
      // Auto assigment removed
      //  this.serviceURLService.createProspectForMaxLife(successData.data.prospectId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      //   this.loading = false;
      // }, errorData => {
      // });
      this.loading = false;
    }, errorData => {
    });
  }


  getProductId() {
    this.serviceURLService.getProductId().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // console.log("Product ID send successfully",successData)

    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  registerNow() {
    this.router.navigate(['email']);
  }

  // getNotificationCount() {
  //   this.serviceURLService.getNotificationCount().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //     this.notificationCounter = successData.response
  //     if (this.notificationCounter > "0") {
  //       this.notificationCount = true;
  //     }
  //   }, errorData => {
  //     console.log("Oops..!! there is some error in prospect creation");
  //     if (errorData.error.status === 403) {
  //       this.error = errorData.error.message;
  //     }
  //   })
  // }

   saveClickEvent(clickOn) {
     var clickedData= {
      email: this.email,
      name: this.name,
      mobile: this.mobile,
      id:this.useId,
      type: clickOn
      }
    this.serviceURLService.saveClicked(clickedData).subscribe((successData: any) => {
      console.log("clicked data saved",clickOn);
    }, errorData => {
      console.log("clicked datanot saved",clickOn);
     
    })
  }

  checkLogOut() {
    var logOut = localStorage.getItem("logOut")
    if (logOut != "2") {
      // localStorage.clear();
      // this.router.navigate(['login']);
    }
  }


  checkAuthVerification(){

    var enToken = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('authToken').trim().slice(1).slice(0,-1))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
 
    var enEmail = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('email').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enMobile = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('mobileNumber').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )
    
    var enId  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('userID').trim())+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var enName  = btoa( btoa(Math.random().toString()).slice(0,8)+ btoa(Math.random().toString()).slice(0,8) +
    btoa(localStorage.getItem('name').trim().replace(/\s/g, '_'))+ btoa((Math.random().toString())).slice(0,8) + btoa((Math.random().toString())).slice(0,8) )

    var authData={
        $v3s6:enMobile,
        r$_dy:enEmail,
        x4$zl:enId,
        b_epqj:enToken,
        hj_5cy:enName
    }
    this.serviceURLService.verifyAuthTokenstatus(authData).subscribe((successData: any) => {
      const resStatus = atob(atob(successData.response.QZ_ipn).slice(10).slice(0,-10));
     //console.log(" resStatus ",resStatus)
      if(resStatus.toLowerCase()=='true'){
         
      } else {
        localStorage.clear();
        this.router.navigate(['login']);
      }     
    }, errorData => {
      // localStorage.clear();
      // this.router.navigate(['login']);
    })
  }

  getAttendanceMFineStatus() { 
    this.serviceURLService.getAttendanceTabStatus(localStorage.getItem('userID')).subscribe((success: any) => {
      const status = {
        attendanceStatus: false,
        mFineFGPC: false,
        mFineFreeSpecialist: false,
        isCorporateHealthCheckupRestricted: false,
        isPsychiatristTab: false
      };
      if(success.response.attendanceStatus && success.response.attendanceStatus==true){
        localStorage.setItem("isDisplayAttendance", "true");
        status.attendanceStatus = true
      } else {
        localStorage.setItem("isDisplayAttendance", "false");
        status.attendanceStatus = false
      } 
      if(success.response.mFineFGPC && success.response.mFineFGPC==true){
        localStorage.setItem("mFineFGPC", "true");
        this.showMFineFGPC = true;
        status.mFineFGPC = true
      } else {
        localStorage.setItem("mFineFGPC", "false");
        this.showMFineFGPC = false;
        status.mFineFGPC = false
      }
      if(success.response.mFineFreeSpecialist && success.response.mFineFreeSpecialist==true){
        localStorage.setItem("mFineFreeSpecialist", "true");
        this.showMFineFreeSpecialist = true;
        status.mFineFreeSpecialist = true
      } else {
        localStorage.setItem("mFineFreeSpecialist", "false");
        this.showMFineFreeSpecialist = false;
        status.mFineFreeSpecialist = false
      }
      if(success.response.isCorporateHealthCheckupRestricted && success.response.isCorporateHealthCheckupRestricted==true){
        localStorage.setItem("isCorporateHealthCheckupRestricted", "true");
        this.isCorporateHealthCheckupRestricted = true;
        status.isCorporateHealthCheckupRestricted = true
      } else {
        localStorage.setItem("isCorporateHealthCheckupRestricted", "false");
        this.isCorporateHealthCheckupRestricted = false;
        status.isCorporateHealthCheckupRestricted = false
      }
      if(success.response.isPsychiatristTab && success.response.isPsychiatristTab==true){
        localStorage.setItem("isPsychiatristTab", "true");
        this.showPsychiatrist = true;
        status.isPsychiatristTab = true
      } else {
        localStorage.setItem("isPsychiatristTab", "false");
        this.showPsychiatrist = false;
        status.isPsychiatristTab = false
      }
      this._sharingDataService.attendanceSubject.next(status);
    },error => {

    })
  }

  getOrUpdateFreeGPCStatus() {
    this.serviceURLService.getAndUpdateFreeGPCStatus(localStorage.getItem('userID'),this.freeGpcStatus).subscribe((success: any) => {
      if(success.response.isFreeGPCSubscribed && success.response.isFreeGPCSubscribed==true){
        localStorage.setItem("isFreeGpcSubscribed", "true");
      } else {
        localStorage.setItem("isFreeGpcSubscribed", "false");
      } 
    },error => {
      console.log(error)
    })
  }

  redirectToMedPay() {
    this.saveClickEvent("Med-Pay");
    let firstname = localStorage.getItem('name').split(' ')[0]
    let middlename = localStorage.getItem('name').split(' ')[1]
    let lastname = localStorage.getItem('name').split(' ')[2]

    if (!middlename && !lastname)
      lastname = 'user'
    else if (middlename && !lastname)
      lastname = middlename
    else if (middlename && lastname)
      lastname = lastname
    
    let mobileNumber = localStorage.getItem('mobileNumber')
    const requestBody = {
      "partner_id": "securenow",
      "user_details": {
        "mobile_number": mobileNumber,
        "firstname": firstname,
        "lastname": lastname
      }
    }
    var windowReference = window.open();
    this.serviceURLService.getMedPayToken().subscribe((successData: any) => {
      const accessToken = successData.access_token
      this.serviceURLService.loginAndredirectToMeday(requestBody, accessToken).subscribe((data: any) => {
        windowReference.location.href = data.response.redirect_url;
      })
    }, error => {
      console.log(error);
    })
  };

  checKClaimsFAQ(){
    // Open the URL in a new tab
          const a = document.createElement('a');
          a.href = 'https://securein.freshdesk.com/support/home';
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          a.click();

          setTimeout(() => {
            this.router.navigate(['/home']);
          }, 500);
          // Close the new tab
  }
  
  backFunction(){
    window.location.replace(environment.pam2Url)
  }

  corporateHealthCheckup(planId: string) {
    this.serviceURLService.corporateHealthCheckUp(this.useId, planId).subscribe((successData: any) => {
      console.log('successData===>', successData)
      const redirectionUrl = successData.response.redirectionUrl;
      // Open the URL in a new tab
      const a = document.createElement('a');
      a.href = redirectionUrl;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.click();

      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
      // Close the new tab
    }, errorData => {
      console.log('errorData===>', errorData)
      setTimeout(() => {
        this.router.navigate(['/home']);
      }, 500);
    })
  }

  callNow(){
    window.location.href = "tel:+919696683999";
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}